import React, { useEffect, useState } from "react";
import { Dropdown, Row, Col, Card, Spinner } from "react-bootstrap";
import authService from "../../../services/authService";
import { useUser } from "../../../context/UserContext";

const CallAnalysis = () => {
  const { token } = useUser();
  const [analyticsData, setAnalyticsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("Select");

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data;
        if (filter === "This Month") {
          data = await authService.getCallAnalyticsThisMonth(token);
        } else if (filter === "This Quarter") {
          data = await authService.getCallAnalyticsThisQuarter(token);
        } else {
          data = await authService.getCallAnalytics(token);
        }
        setAnalyticsData(data);
      } catch (error) {
        console.error("Failed to fetch call analytics data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, filter]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (!analyticsData) {
    return <div>No data available</div>;
  }

  const stats = [
    {
      icon: (
        <img src="/assets/user-check2.svg" alt="New Clients" className="fs-4" />
      ),
      title: "New Clients",
      count: analyticsData.newClients,
      trend: "1.3%",
      color: "bg-success bg-opacity-10",
    },
    {
      icon: (
        <img
          src="/assets/user-plus3.svg"
          alt="Existing Clients"
          className="fs-4"
        />
      ),
      title: "Existing Clients",
      count: analyticsData.existingClients,
      trend: "1.3%",
      color: "bg-primary bg-opacity-10",
    },
    {
      icon: <img src="/assets/shield.svg" alt="Spams" className="fs-4" />,
      title: "Spams",
      count: 0,
      trend: "1.3%",
      color: "bg-danger bg-opacity-10",
    },
  ];

  return (
    <div className="card  border-0 p-4 rounded-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex ">
          <h5 className="fw-bold">Call Analysis</h5>
          <span className="fs-three gray-color ms-4">
            February 01, 2025 - February 06, 2025
          </span>
        </div>
        <Dropdown>
          <Dropdown.Toggle className="border-purple-color fw-bold">
            {filter}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => setFilter("Select")}>
              Select
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setFilter("This Month")}>
              This Month
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setFilter("This Quarter")}>
              This Quarter
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Row className="px-2">
        <Col md={6} className="border border-light-subtle rounded-4">
          <Card className="p-3 border-0 pb-0">
            <div className="my-1">
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="text-muted">Total Calls</h6>
                  <div className="bg-light-total p-3 rounded-circle">
                    <img src="/assets/phone-call-sky.svg" alt="Total Calls" />
                  </div>
                </div>
                <h3 className="fw-bold fs-five-title mb-3">
                  {analyticsData.totalCalls}
                </h3>
                <span className="gray-color fs-one">
                  <img src="/assets/trending-up-call.svg" alt="Up" />{" "}
                  <span className="light-green-color me-1">1.3% </span>
                  <span>Since last month</span>
                </span>
              </div>
            </div>
            <hr className="border-dark-subtle mb-0" />
          </Card>
          <div className=" rounded-3 p-3 w-100 pt-0">
            {stats.map((item, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center py-2"
              >
                <div className="d-flex align-items-center gap-3">
                  <span className={`p-2 rounded-4 ${item.color}`}>
                    {item.icon}
                  </span>
                  <div>
                    <h6 className="mb-2 gray-color fw-semibold">
                      {item.title}
                    </h6>
                    <p className="text-muted small mb-0">Since last month</p>
                  </div>
                </div>
                <div className="text-end">
                  <h6 className="mb-0 fw-semibold text-dark">{item.count}</h6>
                  <p className="text-success small mt-1 mb-0 d-flex align-items-center">
                    <span className="gray-color fs-one">
                      <img src="/assets/trending-up-call.svg" alt="Up" />{" "}
                      <span className="light-green-color">1.3% </span>
                    </span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Col>

        <Col md={6}>
          <Card className="p-3 border border-light-subtle rounded-4 ">
            <div className="my-1">
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="text-muted">Average Call Duration</h6>
                  <div className="bg-light-avg p-3 rounded-circle">
                    <img
                      src="/assets/fluent_call-missed-20-regular.svg"
                      alt="Call Duration"
                    />
                  </div>
                </div>
                <h3 className="fw-bold fs-five-title mb-4">
                  {analyticsData.averageCallDuration || 0}{" "}
                  <small className="fs-one">mins</small>
                </h3>
                <span className="gray-color fs-one">
                  <img src="/assets/trending-up-call.svg" alt="Up" />{" "}
                  <span className="light-green-color  me-1"> 8.5%</span>
                  <span>Since last month</span>
                </span>
              </div>
            </div>
          </Card>
          <Card className="p-3 border border-light-subtle rounded-4 mt-3">
            <div className="my-1">
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="text-muted">Total Minutes Spent</h6>
                  <div className="bg-light-min p-3 rounded-circle">
                    <img
                      src="/assets/mdi_stopwatch-outline.svg"
                      alt="Total Minutes"
                    />
                  </div>
                </div>
                <h3 className="fw-bold fs-five-title mb-4">
                  {analyticsData.totalMinutesSpent}{" "}
                  <small className="fs-one">mins</small>
                </h3>
                <span className="gray-color fs-one">
                  <img src="/assets/trending-up-call.svg" alt="Up" />{" "}
                  <span className="light-green-color me-1">1.3%</span>
                  <span>Since last month</span>
                </span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CallAnalysis;
